import React, { useEffect, useState } from "react";
import XMLViewer from "react-xml-viewer";
import { getPayloadXml } from "../api/payloadService";

const LIGHT_THEME = {
  attributeKeyColor: "#0550ae",
  attributeValueColor: "#0a3069",
  tagColor: "#116329",
  textColor: "#24292f",
  cdataColor: "#0550ae",
  commentColor: "#6e7781",
  separatorColor: "#6e7781",
};

const DARK_THEME = {
  attributeKeyColor: "#79c0ff",
  attributeValueColor: "#a5d6ff",
  tagColor: "#7ee787",
  textColor: "#e6edf3",
  cdataColor: "#79c0ff",
  commentColor: "#8b949e",
  separatorColor: "#8b949e",
};

export default function XmlViewerModal({ row, onClose }) {
  const [xml, setXml] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(false);
  const isDark = document.body.classList.contains("dark");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    setXml(null);
    getPayloadXml(row.docnum, row.payloadType, row.materialNumber, row.supplierNumber)
      .then((data) => {
        if (!cancelled) {
          setXml(data.xml);
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError("Failed to load XML payload.");
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [row]);

  const handleCopy = () => {
    navigator.clipboard.writeText(xml || "").then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div
      className="modal-overlay"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="modal-content">
        <div className="modal-header">
          <div className="modal-title">
            <strong>{row.payloadType}</strong>
            <span className="modal-meta"> &mdash; {row.docnum}</span>
            {row.materialNumber && (
              <span className="modal-meta"> &nbsp;|&nbsp; Mat: {row.materialNumber}</span>
            )}
            {row.supplierNumber && (
              <span className="modal-meta"> &nbsp;|&nbsp; Sup: {row.supplierNumber}</span>
            )}
            {row.plant && (
              <span className="modal-meta"> &nbsp;|&nbsp; Plant: {row.plant}</span>
            )}
          </div>
          <div className="modal-actions">
            {xml && (
              <button className="btn-secondary" onClick={handleCopy}>
                {copied ? "Copied!" : "Copy XML"}
              </button>
            )}
            <button className="btn-close" onClick={onClose}>&#x2715;</button>
          </div>
        </div>

        <div className="xml-viewer-wrap">
          {loading && <div className="xml-loading">Loading&hellip;</div>}
          {error && <div className="payload-error">{error}</div>}
          {!loading && !error && !xml && (
            <div className="xml-loading">No XML payload found for this record.</div>
          )}
          {xml && (
            <XMLViewer
              xml={xml}
              collapsible
              indentSize={2}
              theme={isDark ? DARK_THEME : LIGHT_THEME}
            />
          )}
        </div>
      </div>
    </div>
  );
}
